import { render, staticRenderFns } from "./CertificateItemV2.vue?vue&type=template&id=537a7f0a&scoped=true&"
import script from "./CertificateItemV2.vue?vue&type=script&lang=js&"
export * from "./CertificateItemV2.vue?vue&type=script&lang=js&"
import style0 from "./CertificateItemV2.vue?vue&type=style&index=0&id=537a7f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a7f0a",
  null
  
)

export default component.exports